import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";

export const HowAddTracksInAlbum: React.FC = () => {
  return <div id={"HowAddTracksInAlbum"}>
    <h2>
      Как добавить треки в альбом
    </h2>
    <h4 id={"HowAddTracksInAlbumMainInformation"}>
      Основная информация
    </h4>
    <p>
      Перейдите на вкладку <b>Трек-лист</b>, загрузите музыкальные файлы и заполните все необходимые поля. Порядок
      треков можно менять с помощью перетаскивания – просто кликните левой кнопкой мыши на три вертикальные точки рядом
      с названием и перемещайте курсор с треком. Наводите курсор на значки{" "}
      <FontAwesomeIcon size={"lg"} className={"text-gray-500"} icon={faCircleInfo} />,
      чтобы увидеть подсказки.
      Инструмент со значком <FontAwesomeIcon size={"lg"} className={"text-gray-500"} icon={faCopy} />  применит введённое значение для всех остальных треков альбома. Обратите внимание
      на следующие нюансы:
    </p>
    <ul className={"list-disc"}>
      <li>
        Название релиза после загрузки будет соответствовать наименованию файла трека. Вы можете изменить название
        вручную
      </li>
      <li>
        В качестве жанра по умолчанию указан жанр альбома. При необходимости вы можете изменить жанры отдельных треков,
        выбрав до трёх разных жанров.
      </li>
      <li>
        Если вы владеете авторскими правами на трек, укажите долю в соответствующем поле. Отображение доли доступно
        только до момента публикации черновика, после этого информация отправляется в базу данных и не отображается в
        альбоме.
      </li>
      <li>
        Задайте Точку запуска ключевого фрагмента трека в соответствующем поле. Поле необязательно к заполнению, трек
        появится в соответствующем разделе ВКонтакте автоматически с точкой запуска на 60-й секунде.
      </li>
      <li>
        Рекомендуется загружать файлы .mp3 или .wav размером не более 210 мб и длительностью до 80 минут.
      </li>
    </ul>

    <h4 id={"HowAddTracksInAlbumFinancialInformation"}>
      Финансовые модели
    </h4>
    <ul className={"list-disc"}>
      <li>
        Если ранее вы указывали дату релиза альбома, то при настройке финансовых моделей на треках эта дата будет
        отображаться автоматически после выбора территории. Вы всегда можете изменить даты доступности треков вручную
      </li>
      <li>
        Если даты и территории доступности трека одинаковы на нескольких моделях, примените их для других моделей с
        помощью соответствующей настройки:
        <div className={"text-center"}>
          <img className={"max-h-[350px]"} src={"/help/apply_fin_setup.jpg"} alt={"Добавить новый альбом"} />
        </div>
      </li>
      <li>
        Нажмите на кнопку <b>Применить ко всем трекам</b>, если разрешения треков альбома совпадают. Так вам не придётся
        настраивать разрешения для каждой отдельной композиции
      </li>
      <li>Обратите внимание, сервис Бандл выполняет функцию «доступен в составе альбома». Поскольку площадки такой
        формат доступности пока не поддерживают, релиз с высокой долей вероятности будет блокироваться на площадках.
      </li>
    </ul>
    <b>Не забудьте сохранить изменения перед публикацией альбома.</b>
  </div>;
};
